import { ListaPedidos } from "@/pedidos/listaPedidos";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pedidos/print")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ListaPedidos url="/admin/pedidos/print" />;
}
